<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <h4 class="card-title">Data Table</h4>
            <button v-b-modal.modal-user class="btn btn-success" @click="resetModal"><i class="bx bxs-plus-square mr-1"></i> Add Partner</button>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model.lazy="searchText"
                        type="search"
                        placeholder="Search Name..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <vue-good-table
                  mode="remote"
                  :pagination-options="{
                    enabled: false,
                    mode: 'pages',
                    perPage: perPage,
                    position: 'bottom',
                    perPageDropdown: [5, 10],
                    dropdownAllowAll: false,
                    nextLabel: 'next',
                    prevLabel: 'prev',
                    rowsPerPageLabel: 'Rows per page',
                    ofLabel: 'of',
                    pageLabel: 'page', // for 'pages' mode
                    allLabel: 'All',
                  }"
                  :totalRows="totalRows"
                  :rows="partnerData"
                  :columns="columns"
                  :sort-options="{
                    enabled: false,
                    initialSortBy: {field: 'id', type: 'desc'}
                  }"
              >
                <template slot="table-row" slot-scope="props">
                  <div v-if="props.column.field == 'btn'">
                    <b-button pill size="sm" @click="setModalPartner(props.row)" v-b-modal.modal-user>Edit</b-button>
                    <b-button pill variant="danger" size="sm" @click="deletePartner(props.row)">Delete</b-button>
                  </div>
                </template>
              </vue-good-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <b-modal id="modal-user" :title="modalTitle" button-size="sm">
              <label>Name:</label>
              <b-form-input type="text" v-model="partnerPayload.name" placeholder="Masukkan Nama"></b-form-input>
              <label>Description:</label>
              <b-textarea v-model="partnerPayload.description"></b-textarea>
              <template #modal-footer="{ cancel, ok }">
                <b-button size="sm" @click="cancel">
                  Close
                </b-button>
                <b-button v-if="mode === 'insert'" variant="primary" :disabled="loadingUpdate" size="sm" @click="insertPartner">
                  <div v-if="loadingUpdate">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    Simpan
                  </div>
                </b-button>
                <b-button v-else variant="primary" :disabled="loadingUpdate" size="sm" @click="updatePartner">
                  <div v-if="loadingUpdate">
                    <b-spinner label="Loading..."></b-spinner>
                  </div>
                  <div v-else>
                    Simpan
                  </div>
                </b-button>
              </template>
            </b-modal>

          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import axios from 'axios';
import Swal from "sweetalert2";

export default {
name: "index",
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Partner",
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Partner",
          active: true
        }
      ],
      partnerPayload: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      partnerData: [],
      columns: [
        { field: "id", label: "ID" },
        { field: "name", label: "Name" },
        { field: "description", label: "Deskripsi" },
        { field: "btn", label: "Action" }
      ],
      modalTitle: "Tambah Partner",
      searchText: "",
      mode: "",
      loadingUpdate: false
    }
  },
  methods: {
    fetchPartnerData() {
      let params = queryString.stringify({
        ...{
          name: null,
          sort: '-id',
        }
        , ...this.getArguments}
      )
      this.httpCallPartnerData(params)
    },
    updatePartner() {
      axios.put("/api/partner/"+this.partnerPayload.id, this.partnerPayload).then(resp => {
        const { data } = resp.data
        Swal.fire('Sukses')
        this.$bvModal.hide('modal-user')
        this.fetchPartnerData()
        this.loadingUpdate = false
      });
    },
    httpCallPartnerData(params) {
      axios.get("/api/partner?"+params)
          .then(resp => {
            const { data, total } = resp.data
            this.totalRows = total
            this.partnerData = data
            this.isFetched = true
          });
    },
    resetModal() {
      this.mode = 'insert'
      this.partnerPayload = {}
      this.modalTitle = 'Tambah Partner'
    },
    insertPartner() {
      this.loadingUpdate = true

      axios.post("/api/partner", this.partnerPayload).then(resp => {
        const { message } = resp.data
        if (message !== 'success') {
          Swal.fire({
            icon: 'error',
            title: '',
            text: message,
          })
        } else {
          Swal.fire('Sukses')
          this.$bvModal.hide('modal-user')
          this.fetchPartnerData()
        }
        this.loadingUpdate = false
      });
    },

    setModalPartner(partner) {
      this.mode = 'edit'
      this.partnerPayload = Object.assign({}, partner)
      this.modalTitle = 'Edit Partner'
    },
    deletePartner(rowData) {
      Swal.fire({
        title: "Yakin, hapus data ini",
        text: name,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Iya, hapus!"
      }).then(result => {
        if (result.value) {
          axios.delete("/api/partner/"+rowData.id).then(resp => {
            const { data } = resp.data
            Swal.fire('Sukses')
            this.fetchPartnerData()
          });
        }
      });
    },
  },
  mounted() {
    this.fetchPartnerData()
  }
}
</script>

<style scoped>

</style>